export default __webpack_public_path__ + "static/media/i-exterior.c26436cb.svg";